import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import BKUserSelect from '@/components/BKUserSelect.vue'
import { Studio, StudioUser } from '@/modules/Studios/types'
import { addStudioAdmin, removeStudioAdmin } from '@/enitites/studio/api/endpoints'


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateStudioAdmins',
  props: {
    studio: null
  },
  setup(__props: any) {

const props = __props as {
  studio: Studio
};



const excludedUsersIds = computed(() => props.studio.admins.map((admin) => admin.id))

const addAdmin = async (user: StudioUser) => {
  const resp = await addStudioAdmin(props.studio.id, user.id)
  if (resp) props.studio.admins.push(user)
}

const removeAdmin = async (user: StudioUser) => {
  const resp = await removeStudioAdmin(props.studio.id, user.id)
  if (resp) {
    props.studio.admins = props.studio.admins.filter((admin) => admin.id !== user.id)
  }
}

return { __sfc: true,props, excludedUsersIds, addAdmin, removeAdmin, BKUserSelect }
}

})